import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, shareReplay, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

enum FailedCaterogy {
  ClientProblem = 1,
  ErrorWithServiceInformation = 2,
  VehicleStatus = 3,
  Accident = 4,
  LogisticIssues = 5,
}

export interface FailedServiceOptionDTO {
  Code: string;
  Id: string;
  Category: FailedCaterogy;
}

export interface FailedServiceOption {
  code: string;
  id: string;
  category: FailedCaterogy;
}

export interface FailedServicePayload {
  FailureReasonGuid: string;
  NodeId: string;
  OtherReason?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class FailedServiceService {
  private readonly productsUrl: string = environment.products_url;
  private readonly reasonsEndpoint = `${this.productsUrl}/api/failure-reasons`;
  private readonly trackingUrl: string = environment.trackingUrl;

  private cache$?: Observable<FailedServiceOption[]>;

  constructor(private readonly http: HttpClient) {}

  getFailedReasons(): Observable<FailedServiceOption[]> {
    if (this.cache$) {
      return this.cache$;
    }

    this.cache$ = this.http
      .get<FailedServiceOptionDTO[]>(`${this.reasonsEndpoint}`)
      .pipe(
        map((items) => this.mapToOptions(items)),
        shareReplay(1),
        catchError((error) => {
          console.error('Error loading cancel reasons', error);
          return throwError(() => error);
        })
      );

    return this.cache$;
  }

  private mapToOptions(
    dtos: FailedServiceOptionDTO[] | null | undefined
  ): FailedServiceOption[] {
    if (!Array.isArray(dtos) || dtos.length === 0) {
      return [];
    }

    return dtos
      .filter((dto) => dto?.Code)
      .map((dto) => ({
        code: dto.Code,
        id: dto.Id,
        category: dto.Category,
      }));
  }

  private mapToOption(
    dto: FailedServiceOptionDTO | null | undefined
  ): FailedServiceOption | null {
    if (!dto) {
      return null;
    }
    return {
      code: dto.Code,
      id: dto.Id,
      category: dto.Category,
    };
  }

  markAsFailted(
    orderHash: string,
    payload: FailedServicePayload
  ): Observable<void> {
    return this.http.put<void>(
      `${this.trackingUrl}/service/${orderHash}/failed`,
      payload
    );
  }
}
